module.exports = __webpack_public_path__ + "img/icon_bars.3e77ffbb.svg";